// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"161":"b8588abc","350":"8f8d87db","453":"75dabde4","580":"993e6d2c","933":"1cc59552"}[chunkId] + ".chunk.js";
};